/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGetStationConfigQueryResponse, ContentAiGetStationConfigPathParams, ContentAiGetStationConfig401, ContentAiGetStationConfig403 } from "../models/ContentAiGetStationConfig";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contentAiGetStationConfig } from "../axios/contentAiGetStationConfig";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const contentAiGetStationConfigQueryKey = (stationId: ContentAiGetStationConfigPathParams["stationId"]) => ["api-v2", { url: '/content-ai/v1/station-config/:stationId', params: {stationId:stationId} }] as const

export type ContentAiGetStationConfigQueryKey = ReturnType<typeof contentAiGetStationConfigQueryKey>

export function contentAiGetStationConfigQueryOptions(stationId: ContentAiGetStationConfigPathParams["stationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = contentAiGetStationConfigQueryKey(stationId)
        return queryOptions<ContentAiGetStationConfigQueryResponse, ResponseErrorConfig<ContentAiGetStationConfig401 | ContentAiGetStationConfig403>, ContentAiGetStationConfigQueryResponse, typeof queryKey>({
         enabled: !!(stationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return contentAiGetStationConfig(stationId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get station config for client user
 * {@link /content-ai/v1/station-config/:stationId}
 */
export function useContentAiGetStationConfig<TData = ContentAiGetStationConfigQueryResponse, TQueryData = ContentAiGetStationConfigQueryResponse, TQueryKey extends QueryKey = ContentAiGetStationConfigQueryKey>(stationId: ContentAiGetStationConfigPathParams["stationId"], options: 
{
  query?: Partial<QueryObserverOptions<ContentAiGetStationConfigQueryResponse, ResponseErrorConfig<ContentAiGetStationConfig401 | ContentAiGetStationConfig403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? contentAiGetStationConfigQueryKey(stationId)
         

         const query = useQuery({
          ...contentAiGetStationConfigQueryOptions(stationId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ContentAiGetStationConfig401 | ContentAiGetStationConfig403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}